module.exports = __webpack_public_path__ + "img/new_app_logo.eb0646dd.png";